var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.version === '1')?_c('version1'):_vm._e(),(_vm.version === '2')?_c('version2'):_vm._e(),(_vm.version === '3')?_c('version-ciicshared'):_vm._e(),(_vm.version === 'v2')?_c('version-v2'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }